import {useMemo} from 'react';
import {useLocation} from 'react-router-dom';

import {usePageData} from '../../core';
import {useAppMenu} from '../aside/appMenu';
import {buildTrail, Crumb} from './breadcrumbTrail';

/** Breadcrumb da página atual: menu da pessoa + o que a tela declarou. */
export const useBreadcrumbTrail = (): Crumb[] => {
  const {pathname} = useLocation();
  const menu = useAppMenu();
  const {pageTitle, pageTitleLoading, pageBreadcrumbs, pageHeaderNavigation} =
    usePageData();
  return useMemo(
    () =>
      buildTrail({
        pathname,
        menu,
        pageTitle,
        pageTitleLoading,
        pageBreadcrumbs,
        pageHeaderNavigation,
      }),
    [
      pathname,
      menu,
      pageTitle,
      pageTitleLoading,
      pageBreadcrumbs,
      pageHeaderNavigation,
    ]
  );
};
